import { type AuthAction, AuthControls } from "../../features/auth";
import { Button } from "../ui/button";

interface RemoteHeaderProps {
  conversationName: string | null;
  metadataText: string;
  authErrorMessage: string | null;
  isAuthenticated: boolean;
  authUser: Record<string, unknown> | null;
  pendingAuthAction: AuthAction;
  onSignIn: () => void;
  onSignOut: () => void;
  onOpenSupport: () => void;
  showTroubleshootingEntry: boolean;
  onToggleTroubleshooting: () => void;
}

export function RemoteHeader({
  conversationName,
  metadataText,
  authErrorMessage,
  isAuthenticated,
  authUser,
  pendingAuthAction,
  onSignIn,
  onSignOut,
  onOpenSupport,
  showTroubleshootingEntry,
  onToggleTroubleshooting,
}: Readonly<RemoteHeaderProps>): JSX.Element {
  return (
    <header className="relative z-10 flex shrink-0 flex-row items-start justify-between gap-[0.875rem] border-b border-border bg-card p-3 sm:p-[0.875rem] sm:px-4">
      <div className="flex min-w-0 flex-1 flex-col gap-[0.45rem]">
        <p className="m-0 text-[0.6875rem] font-bold uppercase tracking-[0.06em] text-muted-foreground">
          Conversation Timeline
        </p>
        <h1 className="m-0 text-[1.25rem] font-bold leading-[1.2] text-foreground sm:text-[1.625rem]">
          {conversationName ?? "Waiting for conversation..."}
        </h1>
        <div className="flex flex-wrap items-center gap-2">
          <p
            className="m-0 text-sm leading-[1.3] text-muted-foreground"
            aria-label="Conversation metadata"
          >
            {metadataText}
          </p>
        </div>
        {authErrorMessage ? (
          <p
            className="m-0 rounded-md border border-destructive/30 bg-destructive/10 px-2.5 py-2 text-[0.8125rem] leading-[1.35] text-destructive"
            role="alert"
          >
            {authErrorMessage}
          </p>
        ) : null}
      </div>
      <div className="flex shrink-0 items-center gap-2 self-start">
        <Button type="button" variant="outline" size="sm" onClick={onOpenSupport}>
          Support
        </Button>
        <AuthControls
          isAuthenticated={isAuthenticated}
          user={authUser}
          pendingAction={pendingAuthAction}
          onSignIn={onSignIn}
          onSignOut={onSignOut}
          showTroubleshootingEntry={showTroubleshootingEntry}
          onOpenTroubleshooting={onToggleTroubleshooting}
        />
      </div>
    </header>
  );
}
